// import '../../shared/nav/collapsing_nav'  // removed in v3
import '../house44/nav.js'
import '../shared/no_smooth_scroll.js'
import '../shared/phone.js'
import '../shared/package_gallery/image_gallery.js'
import '../shared/buyers_page_personalizer.js'
import './stripe_styling.js'
import './horizontal_scroll.js'

import PriceFilter from '../shared/price_filter'
import AddToCartForms from '../shared/add_to_cart_forms/index.js'
import HotelIndex from '../shared/add_to_cart_forms/h4h_hotels/hotel_index'
import { store } from'../default/store/index.js'
import CartNav from '../shared/nav/nav_cart/index.js'
import Checkout from '../shared/checkout/index.js'
import DepositRedemptions from '../shared/deposit_redemptions/index.js'
import '../default/carousel_bs5.js'
import '../shared/hide_map.js'
import '../shared/seating_chart_filter.js'
// import './seating_chart_filter'

import 'bootstrap/dist/js/bootstrap.esm.js'
import '../shared/nav/bootstrap_nav.js'

// import '../shared/sentry'
import '../shared/package_comparisons.js'
// import '../shared/disable_reset'
import '../f1/slide_elems.js'

import VueLoader from '../default/vue-loader.js'
import LightBox from '../shared/package_gallery/lightbox_gallery.vue'
import ImageGallery from '../shared/package_gallery/package_gallery.vue'
import OrderListBootstrap from '../default/orders/stripe_orders/order_list_bootstrap'
import AddToCart from '../full-gpe/cart/add-to-cart.js'

let price_filters = document.querySelectorAll('#seating_chart_price')

document.addEventListener('turbo:load', () => {
  AddToCartForms.loadBottomForm()
  CartNav.addCartToNavbar()
  DepositRedemptions.findCustomerDeposits()
  Checkout.loadWithAddOn()
  AddToCart.AddToCart()
  VueLoader.loadVueComponent(ImageGallery, document.getElementById('image_gallery'))
  if (document.getElementById('lightbox_gallery')){
    document.getElementById('lightbox_gallery').classList.add('hide')
  }
  VueLoader.loadVueComponent(LightBox, document.getElementById('lightbox_gallery'))
  VueLoader.loadVueComponent(HotelIndex, document.getElementById('hotelIndex'), store)
  VueLoader.loadVueComponent(OrderListBootstrap, document.getElementById('customer_order_list'))
  VueLoader.loadVueComponent(PriceFilter, document.getElementById('seating_chart_price'), store)

  //ensures mobile price filters load
  price_filters.forEach(elem => {
    if (elem.hasChildNodes() == false) {
      VueLoader.loadVueComponent(PriceFilter, elem, store)
    }
  })
})
